<template>
  <nav class="rx-original-preview" aria-label="지역 분석 바로가기">
    <router-link v-for="item in analyses" :key="item.query" :to="{path:'/realestate',query:{q:item.query}}">
      <span class="rx-original-preview-icon" aria-hidden="true"><v-icon size="22">{{ item.icon }}</v-icon></span>
      <span><strong>{{ item.title }}</strong><small>{{ item.description }}</small></span><b aria-hidden="true">→</b>
    </router-link>
  </nav>
</template>
<script>
export const landingAnalyses = [
  {title:'시도별 분석',query:'시도별 분석',description:'가격·거래·공급의 흐름을 한곳에서',icon:'mdi-map-outline'},
  {title:'시군구별 분석',query:'시군구별 분석',description:'관심 지역의 주요 지표를 자세히',icon:'mdi-city-variant-outline'},
  {title:'지역별 시세·지수 흐름 비교',query:'지역별 시세·지수 흐름 비교',description:'여러 지역의 가격 움직임을 나란히',icon:'mdi-chart-line'}
];
export default {data:()=>({analyses:landingAnalyses})};
</script>
<style scoped>
.rx-original-preview{display:grid;gap:0;margin:22px 0 10px;border-top:1px solid #dce4ee;text-align:left}
.rx-original-preview a{display:flex;align-items:center;gap:14px;min-height:78px;padding:14px 4px;border-bottom:1px solid #dce4ee;color:#23354c;text-decoration:none;transition:background .18s ease}
.rx-original-preview a:hover{background:#f4f7fc}.rx-original-preview a:focus-visible{outline:3px solid #215bea;outline-offset:3px}
.rx-original-preview a>span:nth-child(2){flex:1;min-width:0}.rx-original-preview strong{display:block;font-size:14px;line-height:1.55;font-weight:700;word-break:keep-all}.rx-original-preview small{display:block;margin-top:4px;color:#52667f;font-size:11px;line-height:1.6;word-break:keep-all}
.rx-original-preview-icon{display:flex;align-items:center;justify-content:center;flex:none;width:38px;height:42px;background:#edf3ff;border-radius:5px}.rx-original-preview-icon .v-icon{color:#215bea}.rx-original-preview b{color:#215bea;font-size:18px;font-weight:500}
@media(max-width:540px){.rx-original-preview a{gap:10px}.rx-original-preview strong{font-size:13px}.rx-original-preview small{font-size:11px}}
</style>
